"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var InlineQuoteRenderer = (function (_super) {
    __extends(InlineQuoteRenderer, _super);
    function InlineQuoteRenderer(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.run();
        return _this;
    }
    InlineQuoteRenderer.prototype.run = function () {
        InlineQuoteRenderer.processQuoteNodes(this.getQuoteNodes());
    };
    InlineQuoteRenderer.prototype.getQuoteNodes = function () {
        return this.el.find(".company-quote[data-isin][data-exchange]");
    };
    InlineQuoteRenderer.processQuoteNodes = function (nodes) {
        nodes.each(function (index, node) {
            var isin = node.getAttribute('data-isin');
            var exchange = node.getAttribute('data-exchange');
            InlineQuoteRenderer.fetchQuote(isin, exchange, function (quote) {
                InlineQuoteRenderer.renderQuote(node, quote);
            });
        });
    };
    InlineQuoteRenderer.fetchQuote = function (isin, exchange, callback) {
        jquery_1.default.getJSON(["/quote.xhr", exchange, isin].join("/")).done(callback);
    };
    InlineQuoteRenderer.renderQuote = function (node, quote) {
        var diffClass = "";
        if (quote.difference.charAt(0) === '+') {
            diffClass = "climb";
        }
        if (quote.difference.charAt(0) == '-'
            && quote.difference !== '--') {
            diffClass = "drop";
        }
        node.setAttribute("href", quote.url);
        jquery_1.default("<span>" + quote.ticker + "</span>"
            + "<span>" + quote.currency + "" + quote.price + "</span>"
            + "<span class='" + diffClass + "'>" + quote.difference + "</span>").appendTo(node);
    };
    return InlineQuoteRenderer;
}(Widget_1.Widget));
exports.InlineQuoteRenderer = InlineQuoteRenderer;
